import apiClient from './client';
import { Kota } from '@/types';

export interface KotaListParams {
  page?: number;
  limit?: number;
  search?: string;
  propinsiId?: number;
}

export interface KotaListResponse {
  data: Kota[];
  total: number;
  page: number;
  limit: number;
}

export interface MessageResponse {
  message: string;
}

export const kotaApi = {
  getAll: async (params: KotaListParams = {}): Promise<KotaListResponse> => {
    const response = await apiClient.get('/api/kota', { params });
    return response.data;
  },

  create: async (data: Partial<Kota>): Promise<MessageResponse> => {
    const response = await apiClient.post('/api/kota', data);
    return response.data;
  },

  update: async (id: number, data: Partial<Kota>): Promise<MessageResponse> => {
    const response = await apiClient.put(`/api/kota/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<MessageResponse> => {
    const response = await apiClient.delete(`/api/kota/${id}`);
    return response.data;
  },
};
